import { useParams } from "react-router-dom";
import { BarragemProvider } from "../../context";
import { BarragemRoutes } from "../../routes";

function BarragemApp() {
  const { barragem } = useParams<{ barragem: string; }>();

  return (
    <BarragemProvider barragemId={parseInt(barragem ?? "-1")}>
      <BarragemRoutes />
    </BarragemProvider>
  );
}

export default BarragemApp;
